import { Message } from "element-ui";
function wmsMessage() {}
function setOptions(text) {
  return {
    duration: 1500,
    offset: 90,
    message: text,
    customClass: 'global-messageZindex'
  };
}
wmsMessage.warning = function (text) {
  return Message.warning(setOptions(text));
};
wmsMessage.error = function (text) {
  return Message.error(setOptions(text));
};
wmsMessage.success = function (text) {
  return Message.success(setOptions(text));
};
wmsMessage.info = function (text) {
  return Message.info(setOptions(text));
};
export default wmsMessage;
